<template>
  <div>
    <label
      v-for="(option, key) in props.field.choices"
      :key="key"
      :class="`bg-${themeColor}-100`"
    >
      <input
        :id="option"
        v-model="selectedValue"
        type="checkbox"
        :value="option"
        class="ml-1 mr-3 border-gray-300"
        :class="`bg-${themeColor} text-${themeColor}-600 focus:ring-${themeColor}-500`"
        @change="$emit('update:modelValue', selectedValue)"
      />
      {{ option }}
    </label>
  </div>
</template>

<script setup>
  import { useFormField } from '@/composables/useFormField'
  import { computed } from 'vue'
  import { useThemeColor } from '@/composables/useThemeColor'

  defineEmits(['update:modelValue'])

  const props = defineProps({
    field: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  })

  const { selectedValue } = useFormField(props)
  const themeColor = computed(() => useThemeColor().value)
</script>

<style>
  label {
    display: block;
    padding: 5px;
    border-radius: 3px;
    margin: 5px 0;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
</style>
